import $http from "@/helpers/api";

// initial state
const state = {
  all: [],
  customer: [],
  doc_types: []
};

// getters
const getters = {
  get: state => state.customer,
  getAll: state => state.all,
  getDocTypes: state => state.doc_types
};

// actions
const actions = {
  getAll({ commit }) {
    return new Promise((resolve, reject) => {
      $http.get("/customers").then(resp => {
        let arr = [];
        resp.data.customers.forEach(function(item, i) {
          arr[i] = {
            "#": item.customer_id,
            id: item.id,
            name: item.user.name,
            email: item.user.email,
            document: item.document_type + ": " + item.document_number,
            phone: item.phones.map(o => o["phone"]).join(", ")
          };
        });
        commit("setAll", arr);
      });
      resolve();
    });
  },
  get({ commit }, customerId) {
    return new Promise(resolve => {
      $http.get("/customers/" + customerId).then(resp => {
        commit("set", resp.data.customer);
        resolve();
      });
    });
  },
  add(context, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("/customers", { customer: data })
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  edit({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .put("/customers/" + data.id, { customer: data })
        .then(resp => {
          commit("clear");
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  search(context, data) {
    return new Promise((resolve, reject) => {
      $http
        .get("/customers", { params: data })
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  delete({}, data) {
    return new Promise((resolve, reject) => {
      $http
        .delete("/customers/" + data)
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getDocTypes({ commit }) {
    return new Promise((resolve, reject) => {
      $http
        .get("/doctypes")
        .then(resp => {
          commit("setDocTypes", resp.data);
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

// mutations
const mutations = {
  setDocTypes(state, doc_types) {
    state.doc_types = doc_types;
  },
  setAll(state, customers) {
    state.all = customers;
  },
  set(state, customer) {
    state.customer = customer;
  },
  clear(state) {
    state.customer = [];
  },
  clearAll(state) {
    state.customer = [];
    state.all = [];
    state.doc_types = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
